import React, { useEffect, useState } from "react";
import "./Receipt.css";
import SuccessTick from "../../assets/Images/successTick.svg";
import Paymentprocess from "../../assets/Images/paymentprocess.svg";
import Paymentfail from "../../assets/Images/paymentfail.svg";
import { FaCheck, FaTimes, FaCopy, FaChevronDown } from "react-icons/fa";
import { BsClockFill } from "react-icons/bs";
import linesAnimation from "../../assets/Images/linesAnimation.json";
import Helpimg from "../../assets/Images/successhelp.svg";
import CloseIcon from "@mui/icons-material/Close";
import Lottie from "lottie-react";
import CopyIcon from "../../assets/Images/copy.png";
import successDone from "../../assets/Images/succes-done.svg";
import paymentSuccessICon from "../../assets/Images/paymentSuccessIcon.png";
import paymentFailIcon from "../../assets/Images/paymentFailIcon.png";
import PaymentProcessingIcon from "../../assets/Images/paymentProcessingIcon.png";
import processingDone from "../../assets/Images/processing-done.svg";
import failDone from "../../assets/Images/fail-done.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { data } from "../../Common/Text/NormalText";
import { ImagesPath } from "../../Common/imagespath/imagespath";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { useDispatch, useSelector } from "react-redux";
import { getSettlementDisplayName } from "../../Common/serviceActiveCheck/serviceActiveCheck";
import { getPaidServices } from "../../Common/walletServices/Services";
import {
  clearDetailsToSend,
  setDetailsToSend,
} from "../../redux/slice/detailsToSendSlice";

const Receipt = ({ type, receiptData, handleClose, center }) => {
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [paidServices, setPaidServices] = useState([]);
  const [subServiceList, setSubServiceList] = useState([]);
  const dispatch = useDispatch();
  const features = useSelector((state) => state.activeFeatures.features);
  const userDetails = useSelector((state) => state.user.user);
  console.log(
    "type, receiptData, handleClose, center",
    type,
    receiptData,
    center
  );
  const {
    payOutInitiatedDate,
    payOutInitiatedTime,
    payOutPendingStateDate,
    payOutPendingStateTime,
    payOutSettledDate,
    payOutSettledTime,
    settlementTime,
    settlementDate,
    transactionDate,
    transactionTime,
    failureMessage,
    failuerReason,
    payInStatus,
    payOutStatus,
  } = receiptData || {};

  const fetchServices = async () => {
    const services = await getPaidServices("Receipt");
    const serviceNameOfServices = services.map((ser) => {
      return ser.displayLable;
    });
    const subServiceOfServices = services.map((ser) => {
      return ser.subService;
    });
    setPaidServices(serviceNameOfServices);
    setSubServiceList(subServiceOfServices);
  };

  useEffect(() => {
    dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
    fetchServices();
    localStorage.removeItem("cashfreeWebData");
    localStorage.removeItem("cashfreeFastagData");
    localStorage.removeItem("razorpayData");
    localStorage.removeItem("transactionData");
    localStorage.removeItem("paymentData");
    localStorage.removeItem("phonepeData");
    localStorage.removeItem("payUData");
  }, []);

  const getSubServiceName = () => {
    const sbService = receiptData?.subService;
    if (
      sbService?.toLowerCase() === "payout_settlements" ||
      sbService?.toLowerCase() === "transfer"
    ) {
      return "Bill Payments";
    } else if (
      sbService?.toLowerCase() === "referral_Settlements" ||
      sbService?.toUpperCase() === "REFERRAL_SETTLEMENTS" ||
      sbService?.toLowerCase() == "propartner_settlements"
    ) {
      return "Cashback";
    } else {
      return sbService ? sbService.split(" ").slice(0, 2).join(" ") : "N/A";
    }
  };
  console.log("Sub Service Name:", getSubServiceName());

  const getPaymentStatusArray = () => {
    const isTransactionSettlement =
      receiptData?.serviceName === "Settlements" &&
      subServiceList.includes(receiptData?.subService);

    const getInitialSteps = [
      {
        text: "Process initiated by You",
        time: transactionDate + "," + transactionTime,
        isAvailable:
          transactionDate ||
          transactionTime ||
          payInStatus?.toLowerCase() == "success",
      },
      {
        text: "Payment Received by WYTO",
        time: transactionDate + "," + transactionTime,
        isAvailable:
          transactionDate ||
          transactionTime ||
          payInStatus?.toLowerCase() == "success",
      },
      {
        text: "Payment Initiated",
        time: payOutInitiatedDate
          ? payOutInitiatedDate + "," + payOutInitiatedTime
          : payOutPendingStateDate
          ? payOutPendingStateDate + "," + payOutPendingStateTime
          : `- , -`,
        isAvailable:
          payOutInitiatedDate ||
          payOutStatus?.toLowerCase() == "success" ||
          payOutInitiatedTime ||
          payOutPendingStateDate ||
          payOutPendingStateTime,
      },
      {
        text: "Payment Credited",
        time: payOutSettledDate
          ? payOutSettledDate + "," + payOutSettledTime
          : payOutInitiatedDate
          ? payOutInitiatedDate + "," + payOutInitiatedTime
          : payOutPendingStateDate
          ? payOutPendingStateDate + "," + payOutPendingStateTime
          : failureMessage
          ? failureMessage
          : `- , -`,
        isAvailable:
          payOutSettledDate ||
          payOutStatus?.toLowerCase() == "success" ||
          payOutSettledTime ||
          payOutPendingStateDate ||
          payOutPendingStateTime ||
          failuerReason ||
          failureMessage,
      },
    ];

    const getSettlementSteps = [
      {
        text: "Process initiated by You",
        time: transactionDate + "," + transactionTime,
        isAvailable:
          transactionDate ||
          transactionTime ||
          payInStatus?.toLowerCase() == "success",
      },
      {
        text: "Payment Received to WYTO",
        time: transactionDate + "," + transactionTime,
        isAvailable:
          transactionDate ||
          transactionTime ||
          payInStatus?.toLowerCase() == "success",
      },
      {
        text: "Payment Credited by WYTO",
        time: payOutSettledDate
          ? payOutSettledDate + "," + payOutSettledTime
          : failureMessage,

        isAvailable:
          payOutSettledDate ||
          payOutStatus?.toLowerCase() == "success" ||
          payOutSettledTime ||
          failureMessage ||
          failuerReason,
      },
    ];

    if (isTransactionSettlement) {
      console.log(
        "GetPaymentStatusArray in Recipts in ifelse ===> ",
        getSettlementSteps
      );
      return getSettlementSteps;
    }
    console.log(
      "GetPaymentStatusArray in Recipts ===> ",
      [...getInitialSteps].filter(Boolean)
    );
    return [...getInitialSteps].filter(Boolean);
  };

  const getHeaderContent = () => {
    switch (type) {
      case "SUCCESS":
        return {
          icon: <FaCheck />,
          title: "Payment Successful",
          image: SuccessTick,
        };
      case "PROCESSING":
        return {
          icon: <BsClockFill />,
          title: "Payment Processing",
          image: Paymentprocess,
        };
      case "FAILED":
        return {
          icon: <FaTimes />,
          title: "Payment Failed",
          image: Paymentfail,
        };
      default:
        return {
          icon: <BsClockFill />,
          title: "Payment Processing",
          image: Paymentprocess,
        };
    }
  };

  const getTotalAmount = (details) => {
    if (!details) return "N/A";

    const source = details.detailsToSend ?? details;

    return (
      source.finalPayableAmount ??
      source.totalAmount ??
      source.amount ??
      source.walletAmount ??
      "N/A"
    );
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };
  const mergedData = { ...receiptData };
  console.log("Merged Data:", mergedData);
  const navigate = useNavigate();
  const creditCardExisting = mergedData?.creditCardNumber
    ? mergedData?.creditCardNumber
    : mergedData?.detailsToSend?.creditCardNumber;
  return (
    <div
      className={`receipt-container_vyshu ${type} ${center ? "centered" : ""}`}
    >
      <div className={`receipt-header_vyshu`}>
        <div className="lines-lottie">
          <Lottie animationData={linesAnimation} loop={true} />
        </div>
        <div className="close-help-icons">
          <img src={Helpimg} />
          <CloseIcon className="reciept-btn" onClick={() => handleClose()} />
        </div>
        <img
          className="receipt-header-img-div"
          src={getHeaderContent().image}
        />
        <h2 className="receipt-header-title_vyshu">
          {/* CheckGaiPaid?.includes(getSubServiceName()) ? mergedData?.payInStatus : */}
          PAYMENT {mergedData?.payOutStatus || "PROCESSING"}
        </h2>
      </div>

      <div className="receipt-content_vyshu">
        <div className="receipt-content-scroll-vyshu">
          <div className="payment-info_vyshu">
            <div>
              <div className="pay-det-profile-set">
                <p className="receipt-name"> {mergedData?.customerName}</p>
              </div>

              <div
                className={`payment-amount_vyshu ${
                  type?.toLowerCase() === "success"
                    ? "success-status"
                    : type?.toLowerCase() === "processing" ||
                      type?.toLowerCase() === "reversed"
                    ? "processing-status"
                    : "failed-status"
                }`}
              >
                ₹
                {Number(mergedData?.actualAmount) % 1 === 0
                  ? Number(mergedData?.actualAmount)
                  : Number(mergedData?.actualAmount).toFixed(2)}
              </div>
              <div className="payment-description_vyshu ">
                {mergedData?.serviceName?.toLowerCase() == "settlements" &&
                mergedData?.subService?.toLowerCase() !== "transfer"
                  ? getSettlementDisplayName(
                      features,
                      mergedData?.serviceName,
                      mergedData?.subService
                    )
                  : getSubServiceName()}
              </div>
            </div>
          </div>

          <div className="payment-status_vyshu">
            <div
              className="status-header_vyshu"
              onClick={() => setIsStatusOpen(!isStatusOpen)}
            >
              <span className="status-title_vyshu">Payment Status</span>
              <FaChevronDown
                className={`status-arrow_vyshu ${
                  isStatusOpen ? "open_vyshu" : ""
                }`}
              />
            </div>

            {isStatusOpen && (
              <div className="status-timeline_vyshu">
                {getPaymentStatusArray().map((step, index) => (
                  <div className="timeline-item_vyshu" key={index}>
                    {index == 0 ? (
                      <img
                        src={paymentSuccessICon}
                        className="status-img"
                        alt="Status Icon"
                      />
                    ) : (
                      <img
                        src={
                          step.isAvailable && type?.toLowerCase() == "success"
                            ? paymentSuccessICon
                            : type?.toLowerCase() === "processing"
                            ? PaymentProcessingIcon
                            : paymentFailIcon
                        }
                        className="status-img"
                        alt="Status Icon"
                      />
                    )}

                    <div className="timeline-content_vyshu">
                      <div className="timeline-title_vyshu">{step.text}</div>
                      <div className="timeline-time_vyshu">
                        {step.isAvailable ? step.time : ""}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {getSubServiceName() &&
            getSubServiceName() !== "Bill Payments" &&
            getSubServiceName() !== "Cashback" && (
              <div>
                <div className="payment-details_vyshu">
                  <h3 className="details-title_vyshu">{data?.payDetails}</h3>
                  <div className="details-row_vyshu">
                    <span className="details-label_vyshu">{data?.PayTime}</span>
                    <span className="details-value_vyshu">
                      {mergedData?.transactionDate},
                      {mergedData?.transactionTime}
                    </span>
                  </div>
                  {!paidServices?.includes(getSubServiceName()) &&
                    !paidServices?.includes(
                      getSettlementDisplayName(
                        features,
                        mergedData?.serviceName,
                        mergedData?.subService
                      )
                    ) && (
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.Paid}
                        </span>
                        <span className="details-value_vyshu">
                          {mergedData?.serviceName?.toLowerCase() ==
                          "credit card"
                            ? `${
                                mergedData?.bankCode
                                  ? mergedData?.bankCode
                                  : mergedData?.bankName
                                  ? mergedData?.bankName
                                  : ""
                              } XXXX${creditCardExisting?.slice(-4)}`
                            : mergedData?.subService}
                        </span>
                      </div>
                    )}
                  <div className="details-row_vyshu">
                    <span className="details-label_vyshu">{data?.tID}</span>
                    <span className="details-value_vyshu">
                      {mergedData?.transactionId
                        ? mergedData?.transactionId?.slice(0, 15) + "..."
                        : "N/A"}{" "}
                      <img
                        src={CopyIcon}
                        alt="Copy"
                        className="copy-icon_vyshu"
                        onClick={() => handleCopy(mergedData?.transactionId)}
                      />
                    </span>
                  </div>
                  <div className="details-row_vyshu">
                    <span className="details-label_vyshu">{data?.RId}</span>
                    <span className="details-value_vyshu">
                      {mergedData?.referenceId
                        ? mergedData?.referenceId?.slice(0, 15) + "..."
                        : "N/A"}{" "}
                      <img
                        src={CopyIcon}
                        alt="Copy"
                        className="copy-icon_vyshu"
                        onClick={() => handleCopy(mergedData?.referenceId)}
                      />
                    </span>
                  </div>
                  {paidServices?.includes(
                    getSettlementDisplayName(
                      features,
                      mergedData?.serviceName,
                      mergedData?.subService
                    )
                  ) && mergedData?.ntarTransactionId ? (
                    <div className="details-row_vyshu">
                      <span className="details-label_vyshu">
                        {data?.ntarBizzId}
                      </span>
                      <span className="details-value_vyshu">
                        {mergedData?.ntarTransactionId
                          ? `${mergedData?.ntarTransactionId?.slice(0, 15)}...`
                          : ""}
                        <img
                          src={CopyIcon}
                          alt="Copy"
                          className="copy-icon_vyshu"
                          onClick={() =>
                            handleCopy(mergedData?.ntarTransactionId)
                          }
                        />
                      </span>
                    </div>
                  ) : !paidServices?.includes(getSubServiceName()) &&
                    !paidServices?.includes(
                      getSettlementDisplayName(
                        features,
                        mergedData?.serviceName,
                        mergedData?.subService
                      )
                    ) &&
                    mergedData?.bbpsTransactionId ? (
                    <div className="details-row_vyshu">
                      <span className="details-label_vyshu">
                        {data?.bbpsId}
                      </span>
                      {/* Dont show for the Get Paid  show BBPs */}
                      <span className="details-value_vyshu">
                        {mergedData?.bbpsTransactionId
                          ? `${mergedData?.bbpsTransactionId?.slice(0, 15)}...`
                          : ""}
                        <img
                          src={CopyIcon}
                          alt="Copy"
                          className="copy-icon_vyshu"
                          onClick={() =>
                            handleCopy(mergedData?.bbpsTransactionId)
                          }
                        />
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <hr className="horizontal-dotted-line-vyshu" />
                {/* for BBPS */}

                {getSubServiceName() &&
                  !subServiceList?.includes(getSubServiceName()) && (
                    <div>
                      {mergedData?.userName && (
                        <div className="details-row_vyshu">
                          <span className="details-label_vyshu">
                            {data?.from}
                          </span>
                          <span className="details-value_vyshu">
                            {mergedData?.userName ? mergedData?.userName : ""}
                          </span>
                        </div>
                      )}
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.meId}
                        </span>
                        <span className="details-value_vyshu">
                          {mergedData?.MerchantId
                            ? mergedData?.MerchantId?.slice(0, 15) + "..."
                            : "N/A"}{" "}
                          <img
                            src={CopyIcon}
                            alt="Copy"
                            className="copy-icon_vyshu"
                            onClick={() => handleCopy(mergedData?.MerchantId)}
                          />
                        </span>
                      </div>
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.conFee}
                        </span>
                        <span className="details-value_vyshu">
                          ₹
                          {mergedData?.chargedAmount
                            ? Number(mergedData?.chargedAmount)?.toFixed(2)
                            : mergedData?.detailsToSend?.chargedAmount ? Number(mergedData?.detailsToSend?.chargedAmount)?.toFixed(2) : "N/A"}
                        </span>
                      </div>
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.TotalPay}
                        </span>
                        <span className="details-value_vyshu">
                          ₹{getTotalAmount(mergedData)}
                        </span>
                      </div>
                    </div>
                  )}

                {/* Get Paid */}
                {getSettlementDisplayName(
                  features,
                  mergedData?.serviceName,
                  mergedData?.subService
                ) &&
                  paidServices?.includes(
                    getSettlementDisplayName(
                      features,
                      mergedData?.serviceName,
                      mergedData?.subService
                    )
                  ) && (
                    <div>
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.meId}
                        </span>
                        <span className="details-value_vyshu">
                          {mergedData?.MerchantId
                            ? mergedData?.MerchantId?.slice(0, 15) + "..."
                            : "N/A"}{" "}
                          <img
                            src={CopyIcon}
                            alt="Copy"
                            className="copy-icon_vyshu"
                            onClick={() => handleCopy(mergedData?.MerchantId)}
                          />
                        </span>
                      </div>
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.paidV}
                        </span>
                        <span className="details-value_vyshu">
                          <img
                            src={
                              mergedData?.paymentMethod?.toLowerCase() == "visa"
                                ? ImagesPath?.GetPaidAddamount?.visa
                                : mergedData?.paymentMethod?.toLowerCase() ==
                                  "mastercard"
                                ? ImagesPath?.GetPaidAddamount?.master
                                : ImagesPath?.GetPaidAddamount?.rupay
                            }
                            alt="card"
                            height={28}
                            width={28}
                          />
                          &nbsp;
                          {mergedData?.paymentMode}
                        </span>
                      </div>
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu"></span>
                        <span className="details-value_vyshu">
                          {mergedData?.bankName
                            ? mergedData?.bankName
                            : mergedData?.bankCode
                            ? mergedData?.bankCode
                            : ""}{" "}
                          XXXX
                          {mergedData?.creditCardNumber?.slice(-4)}
                        </span>
                      </div>
                      {/* <div className="details-row_vyshu">
                        <span className="details-label_vyshu"></span>
                        <span className="details-value_vyshu">
                          {mergedData?.creditCardNumber
                            ? "XXXX" + mergedData?.creditCardNumber.slice(-4)
                            : "N/A"}
                        </span>
                      </div> */}
                      <hr className="horizontal-dotted-line-vyshu" />
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.conFee}
                        </span>
                        <span className="details-value_vyshu">
                          ₹{mergedData?.chargedAmount
                            ? Number(mergedData?.chargedAmount)?.toFixed(2)
                            : mergedData?.detailsToSend?.chargedAmount ? Number(mergedData?.detailsToSend?.chargedAmount)?.toFixed(2) : "N/A"}
                        </span>
                      </div>
                      {/* {type == "FAILED" && (
                        <div className="details-row_vyshu">
                          <span className="details-label_vyshu">
                            {data?.Reason}
                          </span>
                          <span className="details-value_vyshu">
                            {mergedData?.failuerReason}
                          </span>
                        </div>
                      )} */}
                      <div className="details-row_vyshu">
                        <span className="details-label_vyshu">
                          {data?.TotalPay}
                        </span>
                        <span className="details-value_vyshu">
                          ₹{getTotalAmount(mergedData)}
                        </span>
                      </div>
                    </div>
                  )}
              </div>
            )}

          {getSubServiceName() &&
            ["Bill Payments", "Cashback"].includes(getSubServiceName()) && (
              <div className="payment-details_vyshu">
                <h3 className="details-title_vyshu">{data?.payDetails}</h3>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.PayTime}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.transactionDate},{mergedData?.transactionTime}
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.Paid}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.beneficiaryName}
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.AccountNo}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.beneficiaryAccountNumber}
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">IFSC Code</span>
                  <span className="details-value_vyshu">
                    {mergedData?.ifscCode}
                  </span>
                </div>
                <hr className="horizontal-dotted-line-vyshu" />
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.tID}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.transactionId
                      ? mergedData?.transactionId?.slice(0, 15) + "..."
                      : "N/A"}{" "}
                    <img
                      src={CopyIcon}
                      alt="Copy"
                      className="copy-icon_vyshu"
                      onClick={() => handleCopy(mergedData?.transactionId)}
                    />
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.UTR}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.payOutUTRNo
                      ? mergedData?.payOutUTRNo?.slice(0, 15) + "..."
                      : "N/A"}{" "}
                    <img
                      src={CopyIcon}
                      alt="Copy"
                      className="copy-icon_vyshu"
                      onClick={() => handleCopy(mergedData?.payOutUTRNo)}
                    />
                  </span>
                </div>

                <hr className="horizontal-dotted-line-vyshu" />
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.from}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.userName}
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.meId}</span>
                  <span className="details-value_vyshu">
                    {mergedData?.MerchantId}
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.paidV}</span>
                  <span className="details-value_vyshu">
                    Settlements ₹{mergedData?.finalPayableAmount}
                  </span>
                </div>
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.conFee}</span>
                  <span className="details-value_vyshu">
                    ₹{mergedData?.chargedAmount
                            ? Number(mergedData?.chargedAmount)?.toFixed(2)
                            : mergedData?.detailsToSend?.chargedAmount ? Number(mergedData?.detailsToSend?.chargedAmount)?.toFixed(2) : "N/A"}
                  </span>
                </div>
                {/* {type == "FAILED" && (
                  <div className="details-row_vyshu">
                    <span className="details-label_vyshu">{data?.Reason}</span>
                    <span className="details-value_vyshu">
                      {mergedData?.failuerReason}
                    </span>
                  </div>
                )} */}
                <div className="details-row_vyshu">
                  <span className="details-label_vyshu">{data?.TotalPay}</span>
                  <span className="details-value_vyshu">
                    ₹{getTotalAmount(mergedData)}
                  </span>
                </div>
              </div>
            )}

          <div className="done-button-vyshu">
            <button
              className={`share-button_vyshu ${type}`}
              onClick={() => handleClose()}
            >
              <img src={successDone} />
              {data?.Done}
            </button>
          </div>
          {/* <div className={`helpDiv ${type}_help`}>
            <p
              className="helpText"
              onClick={() =>
                navigate("/HelpWithQueries", {
                  state: {
                    paymentData: receiptData,
                    paymentType: type,
                    subService: getSettlementDisplayName(
                      features,
                      mergedData?.serviceName,
                      mergedData?.subService
                    ),
                    serviceName: receiptData?.serviceName,
                  },
                })
              }
            >
              Contact here for Any Help
              <ArrowForwardIosRoundedIcon fontSize="18" />
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Receipt;
